import { useEffect } from 'react';
import { DayView } from '@devexpress/dx-react-scheduler-material-ui';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  dayViewLayoutComponent: {
    height: '100%',
  },
});

export const DayViewLayoutComponent = (props: DayView.LayoutProps) => {
  const { classes } = useStyles();

  useEffect(() => {
    if (document.getElementsByClassName('Label-text')[4] != null) {
      let element = document.getElementsByClassName('Label-text')[4];
      element.scrollIntoView();
    }
  }, []);
  return (
    <DayView.Layout
      {...props}
      className={classes.dayViewLayoutComponent}
    ></DayView.Layout>
  );
};
